import { getCurrentTimeRounded } from './utils';

export const defaultTimePickerConfig = {
  minuteInterval: 5,
  useCurrentTimeAsDefault: true,
  defaultTime: '09:00',
  applyButtonColor: '#111827',
  applyButtonHoverColor: '#1f2937',
  applyButtonTextColor: '#ffffff',
  placeholder: 'Выберите время',
  applyLabel: 'Применить',
  dropdownZIndex: 1100,
};

export function createTimePickerConfig(overrides = {}) {
  return {
    ...defaultTimePickerConfig,
    ...overrides,
  };
}

export function resolveDefaultTime(config) {
  const settings = createTimePickerConfig(config);

  if (settings.useCurrentTimeAsDefault) {
    return getCurrentTimeRounded(settings.minuteInterval);
  }

  return settings.defaultTime;
}

export function getPickerThemeStyles(config) {
  const settings = createTimePickerConfig(config);

  return {
    '--tp-apply-bg': settings.applyButtonColor,
    '--tp-apply-bg-hover': settings.applyButtonHoverColor,
    '--tp-apply-text': settings.applyButtonTextColor,
  };
}
